import { Result } from 'antd';
import React, { useEffect } from 'react';
import { useGlobalState } from '../GlobalState';

function PaymentFailure({
  headerContent = null,
  retryPaymentButton = null,
  paymentSuccessfulButton = null,
  errorPayment = null,
  message = 'Please check your internet connection or contact swimbooker support:',
}) {
  const [error] = useGlobalState('paymentError');
  let paymentError = errorPayment ? errorPayment : error;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Uses !== to avoid false-negatives if payment_succeeded is undefined -- returns true for "undefined"
  const paymentSucceeded = Boolean(
    paymentError?.payment_succeeded === undefined ||
      paymentError?.payment_succeeded
  );
  const defaultMessage = paymentSucceeded
    ? 'An error occurred'
    : 'Payment Failure';
  const hasStatus =
    paymentError?.payment_status || paymentError?.payment_status_detail;
  const hasServerIssue = Boolean(paymentError?.server_error_detail);

  return (
    <div className={'pd-20 pd-bottom-30'}>
      <Result
        className={'custom_result mg-top-30'}
        status={paymentSucceeded ? 'warning' : 'error'}
        title={paymentError?.message || defaultMessage}
        subTitle={
          <>
            {hasServerIssue && (
              <>
                There was an issue with our system. Please contact us for
                further information
              </>
            )}
            {headerContent}
            {hasStatus && (
              <p className={'mg-top-20'}>
                <span className={'gSemiBold black'}>
                  {paymentError?.payment_status}:
                </span>{' '}
                {paymentError?.payment_status_detail}
              </p>
            )}
            {hasServerIssue && (
              <p className={'mg-top-20'}>
                <span className={'gSemiBold black'}>Server Error Details:</span>{' '}
                {paymentError?.server_error_detail}
              </p>
            )}
            {!hasStatus && !hasServerIssue && (
              <>
                <p className={'mg-top-20'}>
                  {paymentError
                    ? JSON.stringify(paymentError)
                    : 'No further information available.'}
                </p>
                <p>
                  {message}{' '}
                  <a href={'mailto:support@swimbooker.com'}>
                    support@swimbooker.com
                  </a>{' '}
                  or <a href={'tel:+442081949396'}>(+44) (0) 208 194 9396</a>
                </p>
              </>
            )}
          </>
        }
        extra={paymentSucceeded ? paymentSuccessfulButton : retryPaymentButton}
      />
    </div>
  );
}

export default PaymentFailure;
